import type { ComponentPropsWithoutRef, ElementType } from "react";

import { styled } from "simplydo/react/styled";

import { type UiColorPalette, useUiColor } from "../../utils/UIContext";

type ColorProps = { $color: UiColorPalette };

const StyledSoft = styled.button<ColorProps>`
  background-color: ${({ $color }) => $color.softer};
  color: ${({ $color }) => $color.ink};
  box-shadow: none;

  &:hover {
    background-color: ${({ $color }) => $color.soft};
    color: ${({ $color }) => $color.ink};
  }

  &:active {
    background-color: ${({ $color }) => $color.solid};
    color: ${({ $color }) => $color.onSolid};
  }
`;

type Props = ComponentPropsWithoutRef<"button"> & {
  as?: ElementType;
  className?: string;
};

export function SoftButton({ as, className, ...props }: Props) {
  const uiColor = useUiColor();
  return (
    <StyledSoft as={as} className={className} $color={uiColor} {...props} />
  );
}
